


import { utils_tool } from '@/tool'

let { log, isType, Session } = utils_tool;
/**
 * 检查基础数据
 * @param {*} props 
 */
const _basic_check = (props) => {
    //参数检查
    let { apis } = props;
    //apis检查
    if ((apis, 'Object')) {
        if (!apis['list']) {
            log.error('WizTemplate: 数据请求参数(apis)必须含有列表请求参数:list!')
        }
    } else {
        log.error('WizTemplate: 数据请求参数(apis)必须为数组类型(Array)!')
    }
}

/**
 * 构造请求方法
 * @param {*} key 
 * @param {*} apiParams 
 * @param {*} apis 
 */
const _build_request = (key, apiParams, apis) => {
    let r = apis[key];
    if (r && isType(r, 'Object')) {
        //let params = r['payload']  && r['payload']['apiParams'];
        // if (params && isType(params, 'Object')) {
        //     r['payload']['apiParams'] = { ...params, ...apiParams };
        // } else {
        //     r['payload']['apiParams'] = apiParams;
        // }
        r['payload']['apiParams'] = apiParams;
    } else {
        r = false;
    }
    return r;
}

/**
 * 初始化请求
 * @param {*} apis 
 * @param {*} initApiKeys 
 * @param {*} doAction 
 */
const _doInitRequest = (apis, initApiKeys, doAction) => {
    if (apis && isType(initApiKeys, 'Array')) {
        initApiKeys.forEach(key => {
            let api = apis[key]
            let params = (api['payload'] && api['payload']['apiParams']) || {}
            if (api) {
                doAction(key, params)
            }
        });
    }
}

/**
 * 获取初始参数
 * @param {*} key 
 * @param {*} apis 
 */
const _getInitApiParams = (key, apis, keepInitApiParams = false) => {
    if (apis && key) {
        let api = apis[key]
        if (api) {
            if (!keepInitApiParams) {
                delete apis[key]
            }
            return api
        }
    }
    return {};
}

/**
 * 构造调用接口后的接收方法
 * @param {*} format 
 * @param {*} props 
 * @param {*} state 
 */
const _buildOnChange = (api,listen) => {
    let r = {}
    for (const key in api) {
        r[key] = listen.bind(this,key)
    }
    return r;
}

/**
 * 获取当前页面搜索参数
 * @returns 
 */
const getSearchMap = () => {
    const _key = window.location.hash;
    const _searchMap = Session.get('searchMap') || []
    const _index = _searchMap.findIndex((val) => val.key === _key);
    if (_index !== -1) {
        return _searchMap[_index]['value']
    }
    return {}
}


export {
    _basic_check,
    _build_request,
    _doInitRequest,
    _buildOnChange,
    _getInitApiParams,
    getSearchMap
}